import React from 'react';
import * as S from './styles';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <S.Overlay isOpen={isOpen} onClick={handleOverlayClick}>
      <S.Content>
        {title ? (
          <S.Header>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <S.Title>{title}</S.Title>
          </S.Header>
        ) : (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
        {children}
        {footer && <S.Footer>{footer}</S.Footer>}
      </S.Content>
    </S.Overlay>
  );
};
